import{useState as t,useEffect as i}from"react";function n(n,r=!0){const[a,c]=t(!r);return i((()=>{(async()=>{if(r)try{await n(1)}finally{c(!0)}})()}),[]),{isInitialFetchEnd:a}}export{n as useFetchGridSchema};
